"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createIkon;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function createIkon(Element) {
  const Ikon = _ref => {
    let {
      size = '1em',
      color = 'currentColor',
      ...props
    } = _ref;
    return (
      /*#__PURE__*/
      // Height alone is enough to control the size of the icon.
      // Fill is the attribute used to control color.
      _react.default.createElement(Element, (0, _extends2.default)({
        style: {
          height: size,
          fill: color,
          maxWidth: size
        }
      }, props))
    );
  };
  Ikon.displayName = Element.name;
  Ikon.propTypes = {
    /** The icon size, as any valid CSS value */
    size: _propTypes.default.string,
    /** The icon color, as any valid CSS color */
    color: _propTypes.default.string,
    /** An optional (defaulting) icon title for hovertext */
    title: _propTypes.default.string
  };
  return Ikon;
}